module.exports = __webpack_public_path__ + "static/media/stockholm.a2778aa9.jpg";